<template>
  <b-modal
    ref="batchActionsModal"
    size="full"
    :title="$t('diagnosis.batchActionsModal.title')"
    no-close-on-backdrop
    centered
    modal-class="batch-actions-modal"
    @hide="onHide"
  >
    <b-container
      v-if="showModal"
      fluid
    >
      <elements-selection-view
        v-if="selectionView"
        ref="selectionView"
        @disable-next-button="onDisableNextButton"
      />
      <actions-selection-view
        v-if="actionsView"
        ref="actionsView"
        :selected-elements="selectedElements"
        @selected="onActionsSelectionViewSelected"
        @clearActionView="onClearActionView"
      />
      <apply-actions-view
        v-if="conflictsView"
        ref="applyActionView"
        :selected-elements="selectedElements"
        :template-selected="templateSelected"
        :preformatted-id-selected="preformattedSelected && preformattedSelected.id"
        :preformatted-data="preformattedSelected"
        :action-type-selected="actionTypeSelected"
        :update-case-data="updateCaseData"
        @actionsCompleted="onApplyActionsViewActionsComplete"
      />
      <div
        v-if="!isBatchError"
        class="conflicts-area d-flex align-items-center justify-content-center"
      >
        <div class="text-center">
          <i
            class="fal fa-check-circle success fa-3x p-4"
            aria-hidden="true"
          />
          <div class="p-3">
            <h5>{{ $t('diagnosis.batchActionsModal.finalPageSuccess') }}</h5>
          </div>
        </div>
      </div>
    </b-container>
    <div
      slot="modal-footer"
      class="footer-banner px-4"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            qa="batchAction-cancel-button"
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            v-if="actionsView"
            qa="batchAction-back-button"
            size="sm"
            class="btn__outline btn__outline--primary mr-2"
            @click="previousPage"
          >
            {{ $t('diagnosis.batchActionsModal.back') }}
          </b-button>
          <b-button
            v-if="visibleNextButton"
            :disabled="disabledNextButton"
            qa="batchAction-next-button"
            class="btn--primary"
            size="sm"
            @click="nextPage"
          >
            {{ $t('diagnosis.batchActionsModal.next') }}
          </b-button>
          <b-button
            v-if="actionsViewRendered"
            :disabled="disabledApplyActionsButton"
            qa="batchAction-finalize-button"
            class="btn--primary"
            size="sm"
            @click="applyActions"
          >
            {{ $t('global.finalize') }}
          </b-button>
          <b-button
            v-if="conflictsViewRendered && applyActionsViewActionsComplete"
            qa="batchAction-close-button"
            class="btn--primary"
            size="sm"
            @click="hide"
          >
            {{ $t('diagnosis.batchActionsModal.closeWizard') }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ElementsSelectionView from '@/modules/diagnosisModule/components/BatchActionsModal/views/ElementsSelectionView'
import ActionsSelectionView from '@/modules/diagnosisModule/components/BatchActionsModal/views/ActionsSelectionView'
import ApplyActionsView from '@/modules/diagnosisModule/components/BatchActionsModal/views/ApplyActionsView'
import { DescriptionType } from '@/api/resources/description/description.model'
import { DiagnosisBatchActionType } from '@/modules/diagnosisModule/components/BatchActionsModal/batch-actions.model'

export default {
    name: 'BatchActionsModal',
    components: {
        ElementsSelectionView,
        ActionsSelectionView,
        ApplyActionsView
    },
    props: {
        sample: Object,
        isCaseValidated: Boolean
    },
    data() {
        return {
            updateCaseData: null,
            preformattedSelected: null,
            showModal: false,
            actionTypeSelected: null,
            selectedElements: [],
            toggleSearch: true,
            selectionView: true,
            actionsView: false,
            actionsViewRendered: false,
            conflictsView: false,
            finalView: false,
            searchDone: true,
            templateSelected: null,
            isBatchError: true,
            selected: null,
            selectionViewRendered: false,
            selectionViewData: null,
            conflictsViewRendered: false,
            disabledApplyActionsButton: true,
            applyActionsViewActionsComplete: false,
            disabledNextButton: true
        }
    },
    computed: {
        visibleNextButton() {
            return this.selectionView
        }
    },
    methods: {
        onDisableNextButton(disable) {
            this.disabledNextButton = disable
        },
        onApplyActionsViewActionsComplete() {
            this.applyActionsViewActionsComplete = true
        },
        onActionsSelectionViewSelected(preformattedData) {
            this.disabledApplyActionsButton = false
            this.preformattedSelected = preformattedData
        },
        onClearActionView() {
            this.disabledApplyActionsButton = true
        },
        onHide() {
            this.$_cleanComponentData()
        },
        show() {
            this.showModal = true
            this.$refs.batchActionsModal.show()
            this.$nextTick(() => {
                this.selectionViewRendered = true
            })
        },
        hide() {
            this.$refs.batchActionsModal.hide()
        },
        nextPage() {
            this.selectedElements = this.$refs.selectionView.selectedElements
            this.selectionViewData = this.$refs.selectionView.$data
            this.selectionViewRendered = false
            this.selectionView = false
            this.actionsView = true
            this.$nextTick(() => {
                this.actionsViewRendered = true
            })
        },
        previousPage() {
            this.selectionView = true
            this.actionsView = false
            this.actionsViewRendered = false
            this.disabledNextButton = true
        },
        applyActions() {
            this.actionTypeSelected = this.$refs.actionsView.actionTypeSelected
            this.templateSelected = this.$refs.actionsView.templateData
            this.updateCaseData = this.$refs.actionsView.updateCaseData
            if (this.actionTypeSelected === DiagnosisBatchActionType.TEXT_TEMPLATE || this.actionTypeSelected === DiagnosisBatchActionType.SYNOPTIC_TEMPLATE) {
                if (this.templateSelected.textEditionAllowed) {
                    this.templateSelected.descriptionType = DescriptionType.FREE_TEXT
                    this.templateSelected.templateId = this.templateSelected.id
                } else if (this.actionTypeSelected === DiagnosisBatchActionType.TEXT_TEMPLATE) {
                    this.templateSelected.descriptionType = DescriptionType.TEXT_TEMPLATE
                    this.templateSelected.templateId = this.templateSelected.id
                } else if (this.actionTypeSelected === DiagnosisBatchActionType.SYNOPTIC_TEMPLATE) {
                    this.templateSelected.descriptionType = DescriptionType.SYNOPTIC_TEMPLATE
                }
            }

            this.actionsView = false
            this.actionsViewRendered = false
            this.conflictsView = true
            this.$nextTick(() => {
                this.conflictsViewRendered = true
                if (this.actionTypeSelected === DiagnosisBatchActionType.PREFORMATTED) {
                    this.$nextTick(() => {
                        this.$refs.applyActionView.processRestOfPreformattedElements()
                    })
                }
            })
        }
    }
}
</script>

<style lang="scss">
.batch-actions-modal .btn-group .btn.active {
    background-color: vt-color(primary);
    border-color: vt-color(primary);
    color: vt-color(white-light);
}
.batch-actions-modal .btn-group .btn:hover {
    background-color: vt-color(alt-primary) !important;
    border-color: vt-color(alt-primary) !important;
}
.batch-actions-modal .actions-btn .btn.active {
    background-color: vt-color(primary);
    border-color: vt-color(primary);
    color: vt-color(white-light);
}
.batch-actions-modal .search-section {
    text-transform: uppercase;
    font-size: font-size(small);
    color: vt-color(dark-text);
}
.batch-actions-modal .scroll-area {
    height: calc(100vh - 260px);
    overflow-y: auto;
    overflow-x: hidden;
    max-width: 280px;
}
.batch-actions-modal .results-area {
    padding-left: 0;
}
.batch-actions-modal .header {
    height: 50px;
}
.batch-actions-modal .footer {
    position:absolute;
    bottom:0;
    width:100%;
    left:0;
    height: 50px;
    padding: 0 50px;
}
.batch-actions-modal .title {
    font-size: font-size(big);
}
.batch-actions-modal .modal-body {
    min-height: calc(100vh - 175px);
    border-radius: .3rem;
}
.batch-actions-modal .batch-actions-grid {
    height: calc(100vh - 310px);
}
.batch-actions-modal .grid-container {
    border: 1px solid vt-color(general-border);
    margin-bottom: 0;
}
.batch-actions-modal .selection-zone {
    border: 1px solid vt-color(general-border);
    box-shadow: 0 1px 3px 0 rgba(48, 49, 51, 0.1);
    position: relative;
}
.batch-actions-modal .empty-search {
    border: 1px solid vt-color(general-border);
    box-shadow: 0 1px 3px 0 rgba(48, 49, 51, 0.1);
}
.batch-actions-modal .selection-zone .selection-header {
    text-transform: uppercase;
    color: vt-color(dark-text);
    font-size: font-size(small);
}
.batch-actions-modal .selection-zone .selected-element {
    border-bottom: 1px solid vt-color(general-border);
    padding: 4px 0;
    transition: .2s;
}
.batch-actions-modal .selection-zone .selected-element:hover {
    background: vt-color(light-primary);
    cursor: pointer;
}
.batch-actions-modal .selection-zone .selected-element span {
    color: vt-color(green-radiant);
}
.batch-actions-modal .selection-zone .scroll-area {
    height: calc(100vh - 340px);
    overflow-y: auto;
    overflow-x: hidden;
}
.batch-actions-modal .float-button {
    background: vt-color(primary);
    color: vt-color(white-light);
    position: absolute;
    z-index: 1;
    width: 40px;
    height: 40px;
    top: 0;
    left: -28px;
    bottom: 0;
    margin: auto 0;
    box-shadow: 1px 1px 5px 0 rgba(125, 125, 125, 0.64);
    border-radius: 50%;
    cursor: pointer;
    transition: .3s;
}
.batch-actions-modal .float-button:hover {
    background: vt-color(alt-primary);
}
.batch-actions-modal .float-button i {
    font-size: 20px;
}
.batch-actions-modal .footer-banner .text-right .btn {
    min-width: 140px;
}
.batch-actions-modal .tabs.row,
.batch-actions-modal .no-tabs-area {
    height: calc(100vh - 380px) !important;
    border: 1px solid rgba(0, 0, 0, 0.125);
}
.batch-actions-modal .empty-action {
    height: calc(100vh - 320px) !important;
    border: 1px solid rgba(0, 0, 0, 0.125);
}
.batch-actions-modal .no-tabs-area {
    padding: 15px;
    overflow-y: auto;
}
.batch-actions-modal .text-edition .title {
    font-size: font-size(big);
}
.batch-actions-modal .descriptionText .ql-toolbar {
    display: none;
}
.batch-actions-modal .descriptionText .ql-container {
    word-break: break-word;
}
.batch-actions-modal .ql-container.ql-snow {
    border: none !important;
}
.batch-actions-modal .header-row {
    font-size: font-size(small);
}
.batch-actions-modal .codifications-row {
    color: vt-color(dark-text);
}
.batch-actions-modal .actionSelected {
    border: 1px solid vt-color(green-radiant);
    padding: 10px 20px;
}
.batch-actions-modal .actionSelected i {
    color: vt-color(green-radiant);
    font-size: 18px;
}
.batch-actions-modal .actionSelected .help {
    line-height: 16px;
}
.batch-actions-modal .actionSelected .help span:nth-child(2) {
    font-size: font-size(small);
}
.batch-actions-modal .empty-section {
    font-size: font-size(big);
    color: vt-color(base-text, .3);
    margin-top: 50px;
}
.batch-actions-modal .empty-action .empty-section {
    margin-top: 0;
}
.batch-actions-modal .empty-section i {
    font-size: 30px;
}
.batch-actions-modal .ql-editor {
    min-height: calc(100vh - 450px);
}
.batch-actions-modal .cls-1 {
    fill:#749fff;
}
.batch-actions-modal .cls-2{
    fill:#4680ff;
}
.batch-actions-modal #batchActionsIcon {
    width: 100px;
    opacity: .5;
}
.batch-actions-modal .vertical-line {
    width: 1px;
    background: vt-color(general-border);
    height: 100%;
}
.batch-actions-modal .switch-label {
    font-size: font-size(very-small);
    color: vt-color(dark-text);
}
.batch-actions-modal .switch {
    position: relative;
    display: inline-block;
    width: 30px;
    height: 16px;
    background-color: rgba(0, 0, 0, 0.25);
    border-radius: 20px;
    transition: all 0.3s;
    cursor: pointer;
}
.batch-actions-modal .switch::after {
    content: "";
    position: absolute;
    width: 14px;
    height: 14px;
    border-radius: 14px;
    background-color: white;
    top: 1px;
    left: 1px;
    transition: all 0.3s;
}
.batch-actions-modal input[type="checkbox"]:checked + .switch::after {
    transform: translateX(14px);
}
.batch-actions-modal input[type="checkbox"]:checked + .switch {
    background-color: vt-color(primary);
}
.batch-actions-modal .offscreen {
    position: absolute;
    left: -9999px;
}
.batch-actions-modal .group-header {
    color: vt-color(primary);
    text-transform: uppercase;
}
.batch-actions-modal .conflicts-area {
    height: calc(100vh - 280px);
}
.batch-actions-modal .conflicts-area > div {
    width: 70%;
}
.batch-actions-modal .alert-card {
    border: 1px solid vt-color(grid-general-border);
    border-radius: 3px;
    border-left: 3px solid vt-color(warning);
    background: vt-color(warning, .8);
}
.batch-actions-modal .alert-card i {
    color: vt-color(warning);
    font-size: font-size(very-big);
    margin: 0 10px;
}
.batch-actions-modal .alert-card h3 {
    margin-bottom: 0;
    font-size: font-size(normal);
    font-weight: bold;
}
.batch-actions-modal .alert-card span {
    font-size: font-size(small);
}
.batch-actions-modal .link-line {
    position: absolute;
    width: 100%;
    height: 4px;
    background: vt-color(warning);
    margin-top: -1rem;
}
.batch-actions-modal .table-area {
    color: vt-color(dark-text);
    height: calc(100vh - 270px);
    overflow-y: auto;
    overflow-x: hidden;
}
.batch-actions-modal .table-area .table-row {
    border-bottom: 1px solid vt-color(general-border);
    transition: .2s;
}
.batch-actions-modal .table-area .table-row:hover {
    background: vt-color(light-primary);
}
.batch-actions-modal .warning-message {
    color: vt-color(red-medium) !important;
}
</style>
